export interface ILoaderState {
  loading: boolean;
}

export const initialLoaderState: ILoaderState = {
  loading: false,
};
